<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img src="img/brand/white.png" alt="logo" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand">
          <a href="#.">
            <img src="img/brand/blue.png" />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <li class="nav-item">
          <a slot="title" href="/" class="nav-link" role="button">
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">{{$t('Home')}}</span>
          </a>
        </li>
        <li class="nav-item">
          <router-link to="/donator-details" class="nav-link" role="button">
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">{{$t('Charity_Donators')}}</span>
          </router-link>
        </li>
        <!-- <base-dropdown tag="li" class="nav-item white-space">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">{{$t('Fundraise_For')}} <i class="fa fa-chevron-down"></i></span>
                    </a>
                    <router-link to="/organization-profile" class="dropdown-item">{{$t('Organisation')}}</router-link>
                    <router-link to="/projects" class="dropdown-item">{{$t('Projects')}}</router-link>
        </base-dropdown>-->
        <div>
          <router-link to="/projects" class="nav-link">{{$t('Projects')}}</router-link>
        </div>
      </ul>
      <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto">
        <base-dropdown tag="li" class="nav-item white-space">
          <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">
              {{supportedLanguage[selectedLanguage]}}
              <i class="fa fa-chevron-down"></i>
            </span>
          </a>
          <a
            v-for="lang in supportedLanguageKeys"
            :key="lang"
            @click="changeLanguage(lang)"
            href="javascript:void(0)"
            class="dropdown-item"
          >{{supportedLanguage[lang]}}</a>
          <!-- <router-link to="/." class="dropdown-item">English</router-link>
                    <router-link to="/." class="dropdown-item">Hebrew</router-link>
          <router-link to="/." class="dropdown-item">German</router-link>-->
        </base-dropdown>
        <li class="nav-item">
          <span class="share-links">{{$t('Share')}}:</span>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://www.facebook.com/"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Like us on Facebook"
          >
            <i class="fa fa-facebook-square"></i>
            <span class="nav-link-inner--text d-lg-none">Facebook</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Follow us on Instagram"
          >
            <i class="fa fa-instagram"></i>
            <span class="nav-link-inner--text d-lg-none">Instagram</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://www.twitter.com/"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Follow us on Twitter"
          >
            <i class="fa fa-twitter-square"></i>
            <span class="nav-link-inner--text d-lg-none">Twitter</span>
          </a>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import {
  SUPPORTED_LANGUAGES,
  loadLanguageAsync,
  i18n
} from "@/setup/i18n-setup";
export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  methods: {
    changeLanguage(lang) {
      loadLanguageAsync(lang);
    }
  },
  computed: {
    selectedLanguage() {
      return i18n.locale;
    }
  },
  data() {
    return {
      supportedLanguage: SUPPORTED_LANGUAGES,
      supportedLanguageKeys: Object.keys(SUPPORTED_LANGUAGES)
    };
  }
};
</script>
<style>
</style>
